import { IntlShape } from "react-intl";

let intl: IntlShape;

export const setIntl = (intlObj: IntlShape): void => {
  intl = intlObj;
};

export const getIntl = (): IntlShape => {
  if (!intl) throw new Error("Intl not initialized!");
  return intl;
};
